import json5 from "json5";
import formatXml from "xml-formatter";

import type { Language } from "src/components/editor";

export type FormatResult = {
  output: string | null;
  error: string | null;
};

// Languages we can pretty-print client-side.
const FORMATTABLE_LANGUAGES = new Set(["json", "xml"]);

export function canFormatLanguage(language?: Language): boolean {
  return typeof language === "string" && FORMATTABLE_LANGUAGES.has(language);
}

export function formatCode(value: string, language?: Language): FormatResult {
  try {
    if (language === "json") {
      return {
        output: JSON.stringify(json5.parse(value), null, 4),
        error: null,
      };
    }
    if (language === "xml") {
      return { output: formatXml(value), error: null };
    }
    return {
      output: null,
      error: `No formatter available for ${String(language)}`,
    };
  } catch (e) {
    return {
      output: null,
      error: e instanceof Error ? e.message : String(e),
    };
  }
}
